module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-784d887b3fca2f2b6295f437fee8363d.webp";